import { useTranslation } from 'react-i18next';
import type { To } from 'react-router-dom';

import { NoDataEnDash } from '@packages/components/no-data-en-dash/no-data-en-dash';
import type { GridRenderCellParams } from '@packages/fenrir/components';
import { LinkRouter, Tooltip } from '@packages/fenrir/components';

type LinkCellProps = GridRenderCellParams & {
  to: To;
};

export const LinkCell = (params: LinkCellProps) => {
  const { t } = useTranslation();
  let text = params.value;
  const isBlank = !text && text !== 0;

  if (isBlank && !params.to) return <NoDataEnDash />;

  if (isBlank && params.to) {
    text = t('ui:empty');
  }

  return (
    <Tooltip title={text}>
      <LinkRouter to={params.to} variant="body2" noWrap>
        {text}
      </LinkRouter>
    </Tooltip>
  );
};
